import createApi from 'api/createApi';

const PATCH_WORKSPACE_SECTIONS = [
	'formSchema',
	'statuses',
	'destinations',
	'priorities',
	'actions',
];

export const tags = {
	appeal__workspace__create: 'mw/v2/appeals/create',
	appeal__workspace: 'mw/v2/appeals/workspace',
	appeal__workspace__schema__preview: 'mw/v2/appeals/workspace/schema-preview',
	appeal__workspace__patch__save: 'mw/v2/appeals/workspace/patch-save',
	appeal__workspace__draft__file__upload: 'mw/v2/appeals/workspace/files/upload',
	appeal__workspace__draft__file__delete: 'mw/v2/appeals/workspace/files/delete',
};

export const appealWorkspaceApi = createApi({
	reducerPath: 'mw/appealWorkspaceApi',

	endpoints: (builder) => ({
		appealWorkspaceCreate: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/v2/appeals?fileValues=shared',
				body,
				jsonType: true,
			}),
			providesTags: [tags.appeal__workspace__create],
		}),
		appealWorkspace: builder.query({
			query: ({ appealId, sections = [] }) => {
				const query = ['fileValues=shared'];
				if (Array.isArray(sections) && sections.length > 0) {
					query.unshift(`sections=${sections.map(encodeURIComponent).join(',')}`);
				}

				return {
					method: 'GET',
					url: `/mw/v2/appeals/${appealId}/workspace?${query.join('&')}`,
				};
			},
			providesTags: [tags.appeal__workspace],
		}),
		appealWorkspaceSchemaPreview: builder.mutation({
			query: ({ appealId, filters = {} }) => ({
				method: 'POST',
				url: `/mw/v2/appeals/${appealId}/workspace/schema-preview?fileValues=shared`,
				body: { filters },
				jsonType: true,
			}),
			providesTags: [tags.appeal__workspace__schema__preview],
		}),
		appealWorkspacePatchSave: builder.mutation({
			query: ({ appealId, patch = {}, sections = PATCH_WORKSPACE_SECTIONS }) => {
				const query = ['fileValues=shared'];
				if (Array.isArray(sections) && sections.length > 0) {
					query.unshift(`sections=${sections.map(encodeURIComponent).join(',')}`);
				}

				return {
					method: 'PATCH',
					url: `/mw/v2/appeals/${appealId}?${query.join('&')}`,
					body: patch,
					jsonType: true,
				};
			},
			providesTags: [tags.appeal__workspace__patch__save],
		}),
		appealWorkspaceDraftFileUpload: builder.mutation({
			query: ({ appealId, data = {}, file }) => ({
				method: 'POST',
				url: `/mw/v2/appeals/${appealId}/workspace/files`,
				body: {
					data,
					file,
				},
				file: true,
			}),
			providesTags: [tags.appeal__workspace__draft__file__upload],
		}),
		appealWorkspaceDraftFileDelete: builder.mutation({
			query: ({ appealId, draftFileId }) => ({
				method: 'DELETE',
				url: `/mw/v2/appeals/${appealId}/workspace/files/${draftFileId}`,
			}),
			providesTags: [tags.appeal__workspace__draft__file__delete],
		}),
	}),
});

export const {
	appealWorkspaceCreate,
	appealWorkspace,
	appealWorkspaceSchemaPreview,
	appealWorkspacePatchSave,
	appealWorkspaceDraftFileUpload,
	appealWorkspaceDraftFileDelete,
} = appealWorkspaceApi.endpoints;

export default appealWorkspaceApi;
